import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.5H22M6 15.5H11M7 20H17C19.7614 20 22 17.7614 22 15V9C22 6.23858 19.7614 4 17 4H7C4.23858 4 2 6.23858 2 9V15C2 17.7614 4.23858 20 7 20Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCreditCard;
